import { Authenticated, useGo } from "@refinedev/core";
import { Breadcrumbs } from "components/Breadcrumbs/";
import { MediaProject, ProjectTag } from "pages/media/types";
import { useProjectCreation } from "../hooks/useProjectCreation";
import { useProjectWizardStore } from "../useProjectWizardStore";
import { useSoftPaywall } from "@/providers/SoftPaywallProvider";
import { HeyGeniusProjectCreateForm } from "../components/HeyGeniusProjectCreateForm";

export const HeyGeniusProjectCreatePage = () => {
  const go = useGo();
  const { createProject } = useProjectCreation();
  const { setProject } = useProjectWizardStore();
  const { paywallFlow, resetDismissed, setGraceProjectId } = useSoftPaywall();

  const handleSubmit = async (
    url: string,
    tags: ProjectTag[]
  ): Promise<MediaProject> => {
    const project = await createProject(
      [url],
      "hey_genius",
      tags,
      "en-US",
      false
    );
    setProject(project);
    return project;
  };

  const handleSuccess = (newProject: MediaProject) => {
    resetDismissed();
    if (paywallFlow === "soft_3_exp") {
      setGraceProjectId(newProject.id);
    }
    go({ to: `/media/projects/${newProject.id}/setup` });
  };

  const handleCancel = () => {
    go({ to: "/media/projects/create" });
  };

  return (
    <Authenticated key="heyGeniusProjectCreate">
      <Breadcrumbs />
      <HeyGeniusProjectCreateForm
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Authenticated>
  );
};
